// extracted by mini-css-extract-plugin
export default {"modal":"SidebarModal_modal__3VHR3","fadeIn":"SidebarModal_fadeIn__3BwoU"};